import {
    Box,
    Flex,
    Link,
    Text,
    useDisclosure
} from '@stars-ecom/shared-atoms-ui'
import React, { useContext, useState, useEffect } from 'react'

import { DataLayerUtils, WebsiteContext } from '../context'

const windowGlobal = typeof window !== 'undefined' && window

const NewsletterPopin = (props) => {
  const websiteContext = useContext(WebsiteContext)
  const { newsletter } = props

  function PopinRight({ children }) {
    const [isOpen, setIsOpen] = useState(() => {
      const popinNewsletterOpen = windowGlobal?.localStorage?.getItem('popinNewsletterOpen')
      return popinNewsletterOpen === null ? true : popinNewsletterOpen === 'true'
    })

    useEffect(() => {
      if (windowGlobal?.localStorage?.getItem('popinNewsletterOpen') !== 'false') {
        windowGlobal?.localStorage?.setItem('popinNewsletterOpen', isOpen) }
    }, [isOpen])

    const onToggle = () => setIsOpen(prev => !prev)

    return (
      <Flex position="fixed" 
        bottom="35%"
        right="0"
        width={{ base: '100%', md: '450px'}}
        mr={{ md: '6px' }}
        border={isOpen ? '2px solid' : '0'}
        borderColor={websiteContext?.mainColor}
        transform={isOpen ? 'translateX(0)' : 'translateX(calc(100% - 30px))'}
        transition="transform 0.6s ease-in-out">
        <Flex
          as="button"
          onClick={onToggle}
          height={{ base: 'auto', md: '220px'}}
          width="30px"
          padding="0"
          variant="unstyled"
          borderRadius="0"
          bg="#fff"
          fontWeight="normal"
          boxShadow={isOpen ? 'none' : '-1px -1px 8px rgb(0 0 0 / 50%)'}
          _hover={{ border: '0' }}
          _focus={{ border: '0' }}
          position={{ base: isOpen ? 'absolute' : 'initial', md: 'initial'}}
          top="-10px"
          left="6px"
          >
          <Text
            fontSize={{ base: isOpen ? '36px' : '22px', md: '22px'}}
            h={{ base: isOpen ? '0' : 'auto', md: isOpen ? '100%' : 'auto'}}
            w={{ md: isOpen ? '100%' : 'auto' }}
            minW={{ base: isOpen ? 'initial' : '200px', md: isOpen ? 'initial' : '220px'}}
            justifySelf="center"
            textTransform={{ base: isOpen ? 'initial' : 'uppercase', md: 'uppercase'}}
            fontFamily={websiteContext?.fontFamily}
            fontWeight={{ md: isOpen ? 'bold' : 'normal'}}
            color={websiteContext?.mainColor}
            transform={isOpen ? '' :'rotate(-90deg)'}
            opacity="1"
            transition="opacity 0.6s ease-in-out">{isOpen ? 'x' :'Newsletter'}
          </Text>
        </Flex>
        <Flex
          w="100%"
          h={{ base: '200px', md: '220px'}}
          padding={{ md: '16px 36px 16px 4px' }}
          bg="#fff"
          alignItems="center"
          justifyContent="center"
          opacity={isOpen ? '1' : '0'}
          transition="opacity 0.6s ease-in-out">{children}
        </Flex>
      </Flex>
    )
  }

  return (
    <Flex zIndex="999">
      <PopinRight> 
        <Flex flexDirection="column" textAlign="center" fontFamily="PT Sans Narrow, PT Sans, Arial, sans-serif">
          <Box mb="24px" textTransform="uppercase" fontSize={{ base:'18px', md:'20px'}} dangerouslySetInnerHTML={{ __html: newsletter?.popinTitle }}></Box>
          <Box dangerouslySetInnerHTML={{ __html: newsletter?.popinContent }}></Box>
          <Link
            to="/customer/newsletter/subscribe"
            onClick={() =>
              DataLayerUtils.addEvent({
                event: 'qwampEventLab',
                eventCat: 'NewsletterPopin',
                eventAct: 'Départ inscription',
                eventLab: 'NewsletterPopin'
              })
            }>
            <Flex
              bg={websiteContext?.mainColor}
              m={{ base:'18px auto 0', md:'40px auto 0'}}
              p="12px 24px"
              w="fit-content"
              fontFamily="PT Sans, Arial, sans-serif"
              justifySelf="center"
              border="1px solid"
              _hover={{
                backgroundColor: '#fff',
                color: websiteContext?.mainColor,
                borderColor: websiteContext?.lightColor                  
              }}
              borderRadius="6px"
              color="#fff"
              style={{ cursor: 'pointer' }}>
                Je m'inscris
            </Flex>
          </Link>
        </Flex>
      </PopinRight>
    </Flex>
  )
}

export default NewsletterPopin